import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import Particle from '../Particle'
import { useNavigate } from 'react-router-dom'

function Thankyou() {
  const nagivate = useNavigate()
  setTimeout(() => {
    nagivate('/')
  }, 6000)
  return (
    <Container fluid className="about-section" style={{ height: '80vh' }}>
      <Particle />
      <Container>
        <Row style={{ justifyContent: 'center', padding: '10px' }}></Row>
        <h1 className="project-heading">
          Thank you for Contacting me{' '}
          <strong className="purple">
            I will reply your mail in the next available time{' '}
          </strong>
        </h1>
        <h3 className="project-heading">
          😊
          <strong className="purple"></strong>
        </h3>
      </Container>
    </Container>
  )
}

export default Thankyou
